import React from "react";
import ReactDom from "react-dom";
import {createRoot} from "react-dom/client";
import { OrganizationInterface } from "./organizations/org_interface";

if(document.getElementById("organization_ui_hook")){
    const root = createRoot(document.getElementById("organization_ui_hook"));
    root.render(<OrganizationInterface/>);
}